module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_DoubleDown_16"],"path":[{"$":{"d":"M8,9,1.76,2.2,3.24.84,8,6,12.76.84,14.24,2.2Zm6.24-.45L12.76,7.2,8,12.39,3.24,7.2,1.76,8.55,8,15.35Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_DoubleDown_16.svg
// module id = c+yg
// module chunks = 1